import type { CanonicalProduct } from "@lib/schema";

export function SpecTable({ specs }: { specs: CanonicalProduct["specs"] }) {
  if (!specs.length) {
    return <p>No specifications available yet.</p>;
  }
  return (
    <table className="spec-table">
      <tbody>
        {specs.map((spec) => (
          <tr key={spec.key}>
            <th>{spec.key}</th>
            <td>
              {spec.value}
              {spec.unit ? ` ${spec.unit}` : ""}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
